// Pure revenue-estimation math shared by the public simulator and the admin preview.
export const fmtUsd = (n, cur = "USD") =>
  new Intl.NumberFormat("fr-CA", { style: "currency", currency: cur, maximumFractionDigits: 0 }).format(Math.round(n || 0));
export const fmtPct = (x) => `${Math.round((x || 0) * 100)} %`;

export function findBenchmark(settings, zone, bedrooms) {
  const bd = Math.min(Number(bedrooms), 4);
  return settings.benchmarks.find((b) => b.zone === zone && Number(b.bedrooms) === bd) || null;
}

function scenario(settings, adr, occ, bedrooms, hoaMonthly, price) {
  const nights = Math.round(365 * occ);
  const gross = adr * nights;
  const stays = settings.avg_stay_nights ? nights / settings.avg_stay_nights : 0;
  const cleaning = stays * (Number(settings.cleaning_per_stay[String(Math.min(Number(bedrooms), 4))]) || 0);
  const platform = gross * (settings.platform_pct / 100);
  const fee = gross * (settings.fee_pct / 100);
  const hoa = (Number(hoaMonthly) || 0) * 12;
  const net = gross - fee - platform - cleaning - hoa;
  const roi = price > 0 ? net / price : null;
  return { adr, occ, nights, gross, stays: Math.round(stays), cleaning, platform, fee, hoa, net, netMonthly: net / 12, roi };
}

export function estimate(settings, { zone, bedrooms, hoaMonthly, price }) {
  const b = findBenchmark(settings, zone, bedrooms);
  if (!b) return null;
  return {
    benchmark: b,
    low: scenario(settings, b.adr, b.occ, bedrooms, hoaMonthly, Number(price) || 0),
    high: scenario(settings, b.adr_high, b.occ_high, bedrooms, hoaMonthly, Number(price) || 0),
  };
}
